(function () {
  'use strict';

  function fixSafariInfiniteScroll() {
    // Dawn Horizon uses a <paginated-list> custom element
    var paginatedList = document.querySelector('paginated-list');
    if (!paginatedList) return;

    // The sentinel is a <span ref="viewMoreNext"> inside paginated-list
    var viewMoreNext = paginatedList.querySelector('[ref="viewMoreNext"]');
    if (!viewMoreNext) return;

    // Disconnect the existing observer and replace with a larger rootMargin
    if (paginatedList.infinityScrollObserver) {
      paginatedList.infinityScrollObserver.disconnect();
    }

    var newObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          // Directly call the internal render method
          if (typeof paginatedList._renderNextPage === 'function') {
            paginatedList._renderNextPage();
          } else {
            // Fallback: re-assign the observer to the component's own one
            paginatedList.infinityScrollObserver && paginatedList.infinityScrollObserver.observe(entry.target);
          }
        }
      });
    }, {
      rootMargin: '0px 0px 800px 0px'  // Fire 800px before bottom — Safari needs this
    });

    newObserver.observe(viewMoreNext);
    paginatedList.infinityScrollObserver = newObserver;

    // Scroll fallback — belt and suspenders for Safari portrait
    var loading = false;
    window.addEventListener('scroll', function () {
      if (loading) return;
      var distanceFromBottom = document.documentElement.scrollHeight - window.scrollY - window.innerHeight;
      if (distanceFromBottom < 600) {
        loading = true;
        // Simulate intersection by dispatching a click-like trigger
        viewMoreNext = paginatedList.querySelector('[ref="viewMoreNext"]');
        if (viewMoreNext) {
          var fakeEntry = [{ isIntersecting: true, target: viewMoreNext }];
          // Re-trigger the component's own observer callback indirectly
          viewMoreNext.dispatchEvent(new CustomEvent('srr-trigger-next', { bubbles: true }));
        }
        setTimeout(function () { loading = false; }, 2500);
      }
    }, { passive: true });
  }

  // Run on load and after any dynamic page updates
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixSafariInfiniteScroll);
  } else {
    fixSafariInfiniteScroll();
  }

  // Re-run after filter updates reset the component
  document.addEventListener('page:loaded', fixSafariInfiniteScroll);
  document.addEventListener('shopify:section:load', fixSafariInfiniteScroll);
})();
